var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import PersonMergeService from "../../../Services/PersonMerge.service";
import { AlertInfo, AlertSuccess, } from "../../UI/StandardAlerts/StandardAlerts";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import { MERGE_DIRECTION } from "./DuplicateReviewModal";
const DuplicateConfirmationModal = (_a) => {
    var { duplicate, mergeDirection, setReviewModalOpen, setDuplicateConfirmationModalIsOpen, setDuplicateHasMerged, refreshTable } = _a, modalProps = __rest(_a, ["duplicate", "mergeDirection", "setReviewModalOpen", "setDuplicateConfirmationModalIsOpen", "setDuplicateHasMerged", "refreshTable"]);
    function mergeAction() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (mergeDirection === MERGE_DIRECTION.A_INTO_B) {
                    yield PersonMergeService.mergePeople(duplicate.personA.personId, duplicate.personB.personId);
                }
                else {
                    yield PersonMergeService.mergePeople(duplicate.personB.personId, duplicate.personA.personId);
                }
                setDuplicateHasMerged(true);
                return true;
            }
            catch (err) {
                // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string | undefined'.
                throw new Error(err);
            }
        });
    }
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { modalTitle: "Merge Confirmation", handleSubmit: () => mergeAction(), saveButtonContents: "Ok", keepModalOpenAfterSuccess: _jsx(AlertSuccess, { message: "Merge successful." }), onCloseAfterSuccess: () => {
            setDuplicateConfirmationModalIsOpen(false);
            setReviewModalOpen(false);
            refreshTable();
        }, onModalClosed: () => {
            setDuplicateConfirmationModalIsOpen(false);
        }, children: _jsxs("div", { className: "form-group", children: [_jsx(AlertInfo, { message: "This action is irreversible." }), "Are you sure you want to merge ", mergeDirection, "?"] }) })));
};
export default DuplicateConfirmationModal;
